module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "flex items-start justify-between"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h3', [_vm._v("CÔNG TY TNHH CÔNG NGHỆ MẠNG THÔNG TIN VIỆT NAM")]), _c('ul', {
    staticClass: "list-reset"
  }, [_c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Địa chỉ:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("Số 11, Đoàn Văn Bơ, Phường 13, Quận 4, TP.HCM, Việt Nam.")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Mã số doanh nghiệp:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("0314505650")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Ngày cấp:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("10/07/2017")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Nơi cấp:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("Sở Kế hoạch và Đầu tư Tp. Hồ Chí Minh")])])])]), _c('div', {
    staticClass: "col-4"
  }, [_c('h3', [_vm._v("Liên hệ chúng tôi")]), _c('ul', {
    staticClass: "list-reset"
  }, [_c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Email:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("contact@vngaynay.vn")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Điện thoại:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("02836362391")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Zalo:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("0932728536")])])])])]), _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "small my0"
  }, [_vm._v("Giấy phép thiết lập trang thông tin điện tử tổng hợp trên mạng Số 44/GP – STTTT do Sở Thông tin và Truyền thông Thành phố Hồ Chí Minh cấp ngày 13/9/2017")]), _c('p', {
    staticClass: "small my0"
  }, [_vm._v("Chịu trách nhiệm nội dung:  Lê Phạm Huyền Nhung")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c90fb8b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 923
// module chunks = 1